import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

interface IProps {
    onChange?: (value: [string | undefined | Dayjs, string | undefined | Dayjs] | undefined) => void
    defaultValue?: [string, string]
    extra?: string
    value?: [string, string]
}
const CustomRangePicker = ({ value, onChange, defaultValue, extra = "※ 설정한 기간동안만 예약을 받습니다" }: IProps) => {
    const [dates, setDates] = useState<[string, string]>([defaultValue?.[0] ?? value?.[0] ?? dayjs().toISOString(), defaultValue?.[1] ?? value?.[1] ?? dayjs().add(30, 'd').toISOString()]);

    useEffect(() => {
        onChange?.(dates)
    }, [dates])

    return <>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <DatePicker value={dayjs(dates[0])} defaultValue={dayjs(value?.[0])} style={{ width: '25%' }} onChange={(q: Dayjs) => setDates(w => [q.toISOString(), w[1]])} />
            <div>
                ~
            </div>
            <DatePicker value={dayjs(dates[1])} defaultValue={dayjs(value?.[1])} style={{ width: '25%' }} onChange={(q: Dayjs) => setDates(w => [w[0], q.toISOString()])} />
            <div style={{ marginLeft: '8px', color: 'var(--ant-color-text-description)' }}>
                {extra}
            </div>
        </div>
    </>
}

export { CustomRangePicker }